/**
 * Forge Ledger social presence — single source of truth.
 *
 * Update the URLs here and every social card/strip across the app picks
 * up the change. Do NOT inline new URLs anywhere else.
 *
 * `enabled: false` hides the link across the app — useful when the
 * account doesn't yet exist (broken outbound links hurt SEO and trust).
 */
export const SOCIAL = {
  twitter: {
    handle: '@_ForgeLedger',
    label: 'X (Twitter)',
    url: 'https://x.com/_ForgeLedger',
    enabled: true,
  },
  facebook: {
    handle: 'Forge Ledger',
    label: 'Facebook page',
    url: 'https://www.facebook.com/profile.php?id=61590492792706',
    enabled: true,
  },
  linkedin: {
    handle: 'Forge Ledger',
    label: 'LinkedIn page',
    // Canonical public Company Page URL (drop the ?viewAsMember=true and
    // /about/ suffix — those are admin-preview-only and add noise to
    // crawled links).
    url: 'https://www.linkedin.com/company/forge-ledger-personal-finance/',
    enabled: true,
  },
};

/** Convenience accessor for callers that just want the live socials. */
export const ENABLED_SOCIALS = Object.entries(SOCIAL)
  .filter(([, v]) => v.enabled !== false)
  .map(([key, v]) => ({ key, ...v }));
